import {noop} from '@yandex-delivery/utils'
import {type PropsWithChildren, createContext, useContext} from 'react'

import type {OrderFormState} from '../types'

/** Значение контекста ActionContext */
type ActionContextValue = {
  /**
   * Коллбэк на сабмит формы
   * @param data Стейт формы
   */
  onSubmit: (data: OrderFormState) => void
}

/** Пропсы провайдера ActionProvider */
type ActionProviderProps = PropsWithChildren<ActionContextValue>

const ActionContext = createContext<ActionContextValue>({
  onSubmit: noop,
})

/** Провайдер контекста ActionContext */
export const ActionProvider = ({children, ...contextValue}: ActionProviderProps) => (
  <ActionContext.Provider value={contextValue}>{children}</ActionContext.Provider>
)

/**  Хук для получения значения контекста ActionContext */
export function useActionContext(): ActionContextValue {
  const context = useContext(ActionContext)

  if (!context) {
    throw new Error('useActionContext has to be used within ActionProvider')
  }

  return context
}
